// hqCompany.js — 본사 판정 (companyFeatures.js 284줄에서 떼어냄, 2026-10-19 — 5단계 홍보물 5-1, 300줄 규칙).
//   글자 그대로 옮겼다. companyFeatures.js 가 그대로 다시 내보내 가져다 쓰는 곳은 바뀌지 않는다.

// ── 본사 판정 (2026-09-11) ───────────────────────────────────────────────────
//
//   본사 = 이 사이트의 주인 회사. 파인그룹이면 PINE, 미팅링크면 LINK.
//
//   **정본은 서버다** — /api/me 의 hqCompanyCode (장부의 운영 테넌트 대표 회사, 2026-09-11).
//   고객 테넌트(유기자차·삼성 등)를 아무리 추가해도 이 답은 안 바뀐다.
//
//   폴백은 서버가 그 값을 아직 안 줄 때만 쓴다(배포 순서상 프론트가 먼저 올라간 경우).
//     내 소속 회사인데 외부 회사 목록에는 없는 코드 = 본사.
//     SUNCREAM 처럼 자기 회사가 외부 회사로 등록된 테넌트 관리자는 이 폴백에서 본사가 없다 —
//     그쪽은 /admin/ext/{코드}/* 가 정식 주소라 돌려보내면 자기 화면을 잃는다.
//     목록이 비어 있으면(못 불러왔을 수 있다) 아무도 본사로 보지 않는다(fail-safe).
export function resolveHqCompanyCode(me, externalCompanies) {
  const fromServer = String(me?.hqCompanyCode || '').toUpperCase();
  if (fromServer) return fromServer;

  const mine = String(me?.company?.code || me?.company_code || '').toUpperCase();
  const list = Array.isArray(externalCompanies) ? externalCompanies : [];
  if (!mine || list.length === 0) return '';
  const isExternal = list.some((c) => String(c?.code || '').toUpperCase() === mine);
  return isExternal ? '' : mine;
}

/**
 * /admin/ext/{code}/{기능} 으로 들어왔을 때 돌려보낼 곳. 없으면 null(그대로 통과).
 *   본사 코드로 들어온 경우에만 돌려보낸다 — 본사는 문이 하나여야 같은 회사 데이터가
 *   두 이름으로 갈리지 않는다.
 */
export function hqRedirectPath(hqCompanyCode, code, feature) {
  const hq = String(hqCompanyCode || '').toUpperCase();
  const here = String(code || '').toUpperCase();
  if (!hq || here !== hq) return null;
  return feature?.hqPath || null;
}

/**
 * 본사 화면이 서버에 보낼 회사값 (2026-09-11 C3 2단계).
 *   장부가 답한 주인 회사를 쓰고, 못 정했으면 'PINE' 으로 되돌아간다 —
 *   'PINE' 은 이 시스템에서 오랫동안 "본사" 를 뜻해 온 값이라 지금까지의 동작 그대로다.
 *   파인그룹은 답이 'PINE' 이라 어느 쪽이든 보내는 값이 같다.
 */
export function hqCodeOrDefault(hqCompanyCode) {
  return String(hqCompanyCode || '').trim().toUpperCase() || 'PINE';
}
